export default function PHP_AjaxXML() {
  return (
    <div>
      <h1>PHP_AjaxXML</h1>
    </div>
  );
}
